import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'

import { getMetricOptions } from '@aytm/app/stats/page/question-views/ad/lib/metrics'
import { calcTableProps } from '@aytm/app/stats/page/question-views/ad/lib/table-utils'

import useAdTestingState from '@aytm/app/stats/page/question-views/ad/states/useAdTestingState'

// components
import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'
import Table from '@aytm/app/stats/components/data-views/table/components/Table'

import Media from '@aytm/app/stats/page/question-views/ad/components/Media'
import Controls from '@aytm/app/stats/page/question-views/ad/components/Controls'

const Block = ({
  id,
  link,
  video,
  image,
  answer,
  params,
  paramsRevision,
  repeatAd,
  mediaType,
  socialType,
  postType,
  components,
  isSurveyGuest,
  isReportXpert,
  disabled,
  onReady,
  onStateChange
}) => {
  const { config, onModelChange } = useAdTestingState({ params, paramsRevision, onReady, onStateChange })

  const options = getMetricOptions(mediaType, socialType, postType)
  const values = config?.metrics || options.map(option => option.value)

  const tableProps = calcTableProps({ answer, config, options, repeatAd })

  // Selecting every metric is no filter at all, so the key is dropped rather than stored;
  // an empty selection is a distinct state and is kept.
  const onConfigChange = (key, value) => {
    const next = { ...(config || {}) }

    if (value.length === options.length) delete next[key]
    else next[key] = value

    onModelChange?.({ config: next })
  }

  return (
    <BlockWrapper {...{ id, link, answer, isSurveyGuest, isReportXpert }}>
      {isComponentOn(components, 'media') && <Media id={id} mediaType={mediaType} video={video} image={image} />}
      {isComponentOn(components, 'controls') && !isSurveyGuest && (
        <Controls options={options} values={values} disabled={disabled} onConfigChange={onConfigChange} />
      )}
      {isComponentOn(components, 'table') && <Table id={id} {...tableProps} />}
    </BlockWrapper>
  )
}

Block.displayName = 'Block'

Block.propTypes = {
  id: PropTypes.string,
  link: PropTypes.string,
  video: PropTypes.object,
  image: PropTypes.object,
  answer: answerPropType,
  paramsRevision: PropTypes.number,
  params: PropTypes.shape({ ad: PropTypes.object }),
  repeatAd: PropTypes.number,
  mediaType: PropTypes.string,
  socialType: PropTypes.string,
  postType: PropTypes.string,
  components: PropTypes.object,
  isSurveyGuest: PropTypes.bool,
  isReportXpert: PropTypes.bool,
  disabled: PropTypes.bool,
  onReady: PropTypes.func,
  onStateChange: PropTypes.func
}

export default Block
